// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"8b70f45f","551":"2fc0a45e"}[chunkId] + ".chunk.js";
};